// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"3f72a898","767":"70e47617"}[chunkId] + ".chunk.js";
};